import map from 'lodash/map';
import uniq from 'lodash/uniq';
import React, {Component} from 'react';
// import {connect} from '~/redux/connect';
import { connect } from '~/redux/connect';
import {getLoadedModels, isAuthenticated} from "~/stateGetter";
import ModelManager from './ModelManager';
import ModConfigCache from "~/ui/ModelDataManager/ModConfigCache";
import { Box } from "~/native-ui";
import ModelDataManager from "./ModelDataManager";

export class ModelTreeDataManager extends Component {
    static propTypes = {};

    render() {
        let { modelIds, modelNames } = this.props;

        let managers = map(modelIds, (modelId ) => <ModelManager modelId={modelId} key={modelId} />);
        let dataManagers = map(modelNames, (modelName) => <ModelDataManager modelId={modelName} key={modelName} />);
        
        return <Box display="none">
            {dataManagers}
            {managers}
        </Box>;
    }
}

const RXModelTreeDataManager = connect(
    (state) => {
        let loadedModels = getLoadedModels(state);
        // console.log('-----------------------------------CHANGED');
        // console.log('CHANGED A', state.lastAction.type, map(loadedModels, 'modelId'));

        return {
            modelIds: map(loadedModels, 'modelId'),
            modelNames: uniq(map(loadedModels, 'modelName')),
        }
    },
    (dispatch) => ({})
)(ModelTreeDataManager);

export default RXModelTreeDataManager;